import React from 'react';
import { navItems } from '../mockData';
import { Instagram, Twitter, Facebook, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="w-full bg-black text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Large Logo */}
        <div className="text-center mb-12">
          <h2 className="text-6xl md:text-9xl font-bold tracking-tight">
            BINTANG EMON
          </h2>
        </div>

        {/* Navigation Links */}
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-8 mb-12 bg-gradient-to-r from-orange-500 to-orange-600 py-6 rounded-lg">
          {navItems.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="text-white text-sm md:text-base font-semibold hover:text-gray-200 transition-colors duration-200"
            >
              {item.name}
            </a>
          ))}
        </div>

        {/* Social Media Icons */}
        <div className="flex justify-center items-center gap-6 mb-8">
          <a
            href="https://www.instagram.com/bintangemon/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-orange-500 transition-colors duration-200"
          >
            <Instagram size={24} />
          </a>
          <a
            href="https://x.com/bintangemon"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-orange-500 transition-colors duration-200"
          >
            <Twitter size={24} />
          </a>
          <a
            href="https://www.facebook.com/gustibintangemon/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-orange-500 transition-colors duration-200"
          >
            <Facebook size={24} />
          </a>
          <a
            href="https://www.youtube.com/@BintangEmonn"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-orange-500 transition-colors duration-200"
          >
            <Youtube size={24} />
          </a>
        </div>

        {/* Copyright */}
        <div className="text-center text-gray-400 text-sm">
          <p>© 2025 Bintang Emon. All rights reserved.</p>
          <p>Powered By{' '}
            <a
              href="https://mpstore.co.id/"
              target="_blank"
              rel="noopener noreferrer"
              className='hover:text-orange-500 transition-colors duration-200'
            >MPStore</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;